import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const PlayButtonContainer = styled.a<{ $isScores?: boolean; $hidden?: boolean }>`
    display: ${({ $hidden }) => ($hidden ? 'none' : 'flex')};
    width: ${({ $isScores }) => ($isScores ? '48px' : '44px')};
    height: 44px;
    justify-content: center;
    align-items: center;
    border-radius: 44px;

    svg {
        cursor: pointer;
        fill: none;
        height: ${({ $isScores }) => ($isScores ? '24px' : '33px')};
        width: ${({ $isScores }) => ($isScores ? '24px' : '33px')};

        ${BaseStyle.Mixins.screenSizes.large} {
            height: ${({ $isScores }) => ($isScores ? '24px' : '48px')};
            width: ${({ $isScores }) => ($isScores ? '24px' : '48px')};
        }
    }

    rect {
        fill: ${({ theme }) => theme.Surface.disabled};
    }

    path {
        fill: ${({ theme }) => theme.Utility.cta};
    }
`;
